var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "megaphone-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.70701 1.69843L4.82622 3.56129C4.52755 3.70466 4.20842 3.74058 3.8831 3.6677C3.6702 3.62001 3.56373 3.59616 3.47801 3.58637C2.4135 3.46481 1.75 4.30732 1.75 5.27615V5.80783C1.75 6.77668 2.4135 7.61918 3.47801 7.49762C3.56373 7.48782 3.67021 7.46396 3.8831 7.4163C4.20842 7.34338 4.52755 7.37932 4.82622 7.5227L8.70701 9.38558C9.59782 9.81322 10.0432 10.027 10.5399 9.86035C11.0365 9.69369 11.2069 9.33605 11.5479 8.62082C12.484 6.65686 12.484 4.42715 11.5479 2.46314C11.2069 1.74791 11.0365 1.3903 10.5399 1.22363C10.0432 1.05698 9.59782 1.27079 8.70701 1.69843Z",
    stroke: "var(--stroke-0, #8A6CC8)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.68259 12.116L5.81263 12.833C3.8517 11.2778 4.09127 10.5361 4.09127 7.58301H4.75267C5.02107 9.25187 5.65419 10.0423 6.52778 10.6146C7.0659 10.967 7.17685 11.7086 6.68259 12.116Z",
    stroke: "var(--stroke-0, #8A6CC8)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.375 7.29199V3.79199",
    stroke: "var(--stroke-0, #8A6CC8)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.47be10d556bec51865f2b6f6e17bfeec.svg";
export { ForwardRef as ReactComponent };